import React, {lazy} from "react";
if (!Array.prototype.flat) {
    Array.prototype.flat = function(depth:number = 1) {
        // @ts-ignore
        return this.reduce((acc:any[], val:any[]) =>
            Array.isArray(val) && depth > 0 ? acc.concat(val.flat(depth - 1)) : acc.concat(val), []);
    };
}
const applyReactInVueAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/applyReactInVue'
    );
const applyPureReactInVueAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/pureReactInVue'
    );
const lazyReactInVueAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/lazyReactInVue'
    );
const lazyPureReactInVueAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/lazyPureReactInVue'
    );

const applyVueInReactAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/applyVueInReact'
    );
const applyPureVueInReactAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/pureVueInReact'
    );
const lazyVueInReactAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/lazyVueInReact'
    );
const lazyPureVueInReactAsync = ()=>import(
    /* webpackChunkName: "reactVue" */
    '../vue/lazyPureVueInReact'
    );
let hasLoadedSyncFunc = false;
let tempFunc:any = {};
const loadSyncFunc = ()=>{
    if(hasLoadedSyncFunc) return;
    hasLoadedSyncFunc = true;
    let setFunc =(funcName: string)=>{
        return (result:any)=>{
            tempFunc[funcName] = result.default
        }
    }
    lazyReactInVueAsync().then(setFunc('lazyReactInVue'))
    lazyPureReactInVueAsync().then(setFunc('lazyPureReactInVue'))
    applyReactInVueAsync().then(setFunc('applyReactInVue'))
    applyPureReactInVueAsync().then(setFunc('applyPureReactInVue'))
    applyVueInReactAsync().then(setFunc('applyVueInReact'))
    applyPureVueInReactAsync().then(setFunc('applyPureVueInReact'))
}

const lazyVueInReactPublic = (lazyImport:()=>Promise<any>)=>{
    return (asyncImport: ()=>Promise<any>, useVueOptions?:any)=>{
        return lazy(() => new Promise(async (resolve) => {
            lazyImport().then(async (result)=>{
                loadSyncFunc();
                let comp = await result.default(asyncImport, useVueOptions)
                // @ts-ignore
                resolve(comp);
            })
        }))
    }
}
const applyPublic = (funcName: string)=>{
    return (component: any, options: any)=>{
        return tempFunc?.[funcName](component,options);
    }
}
const applyVueInReact =  applyPublic('applyVueInReact');
const applyPureVueInReact =  applyPublic('applyPureVueInReact');
const lazyVueInReact = lazyVueInReactPublic(lazyVueInReactAsync);
const lazyPureVueInReact =  lazyVueInReactPublic(lazyPureVueInReactAsync);
const lazyReactInVue =  applyPublic('lazyReactInVue');
const lazyPureReactInVue =  applyPublic('lazyPureReactInVue');
const applyReactInVue =  applyPublic('applyReactInVue');
const applyPureReactInVue =  applyPublic('applyPureReactInVue');

/**
 * 异步加载react，可传依赖
 * @param asyncImport
 * @param options
 */
const lazyReact = (asyncImport: any, options?:{plugins: string[]})=>{
    const {plugins=[]} = options||{};
    return React.lazy(()=>{
        return new Promise(async (resolve)=>{
            if(plugins.length) {
                await window.weappEcodesdk.pluginManager.loadPlugin(plugins);
            }
            asyncImport().then((result:any)=>{
                resolve(result);
            })
        })
    })
}

export {
    applyVueInReact,
    applyPureVueInReact,
    lazyVueInReact,
    lazyPureVueInReact,
    lazyReactInVue,
    lazyPureReactInVue,
    applyReactInVue,
    applyPureReactInVue,
    lazyReact
}